import type { BreadCrumbItem } from "~/models/BreadCrumbItem"

export const MAIN_ROUTE = "store"

export const breadCrumb_menu: BreadCrumbItem = {
    title: "home.store",
    route: MAIN_ROUTE,
    icon: "home",
    color: "gray-9",
    children: [
        {
            title: "products.title",
            route: "products.index",
            icon: "inventory_2",
            color: "gray-9",
            children: [
                {
                    title: "products.create",
                    route: "products.create",
                    icon: "add",
                    color: "gray-9",
                },
                {
                    title: "products.edit",
                    route: "products.edit",
                    icon: "edit",
                    color: "gray-9",
                },
            ],
        },
        {
            title: "users.title",
            route: "users.index",
            icon: "group",
            color: "gary-9",
            children: [
                {
                    title: "users.create",
                    route: "users.create",
                    icon: "add",
                },
                {
                    title: "users.edit",
                    route: "users.edit",
                    icon: "edit",
                },
            ],
        },
        {
            title: "roles.title",
            route: "roles.index",
            icon: "verified_user",
            children: [
                {
                    title: "roles.create",
                    route: "roles.create",
                    icon: "add",
                },
                {
                    title: "roles.edit",
                    route: "roles.edit",
                    icon: "edit",
                },
            ],
        },
        {
            title: "point_of_sales.title",
            route: "point_of_sales.index",
            icon: "house",
            children: [
                {
                    title: "point_of_sales.create",
                    route: "point_of_sales.create",
                    icon: "add",
                },
                {
                    title: "point_of_sales.edit",
                    route: "point_of_sales.edit",
                    icon: "edit",
                },
            ],
        },
        {
            title: "services.title",
            route: "services.index",
            icon: "handyman",
            children: [
                {
                    title: "services.create",
                    route: "services.create",
                    icon: "add",
                },
                {
                    title: "services.edit",
                    route: "services.edit",
                    icon: "edit",
                },
            ],
        },
        {
            title: "services.title",
            route: "store.services",
            icon: "handyman",
        },
        {
            title: "home.contact_us",
            route: "contact",
            icon: "phone",
        },
        {
            title: "offers.title",
            route: "offers.index",
            icon: "shop",
            children: [
                {
                    title: "offers.create",
                    route: "offers.create",
                    icon: "add",
                },
                {
                    title: "offers.edit",
                    route: "offers.edit",
                    icon: "edit",
                },
            ],
        },
        {
            title: "attributes.title",
            route: "attributes.index",
            icon: "extension",
            children: [
                {
                    title: "attributes.create",
                    route: "attributes.create",
                    icon: "add",
                },
                {
                    title: "attributes.edit",
                    route: "attributes.edit",
                    icon: "edit",
                },
            ],
        },
        {
            title: "brands.title",
            route: "Admin-brands",
            icon: "extension",
            children: [
                {
                    title: "brands.create",
                    route: "Admin-brands-create",
                    icon: "add",
                },
                {
                    title: "brands.edit",
                    route: "Admin-brands-id",
                    icon: "edit",
                },
            ],
        },
        {
            title: "shoppingCard.sale_in_store",
            route: "sales_buy_card",
            icon: "storefront",
        },
        {
            title: "shoppingCard.my",
            route: "shoppingCard.my",
            icon: "credit_card",
            children: [
                {
                    title: "shoppingCard.recharged_card",
                    route: "shoppingCard.recharge",
                    icon: "request_page",
                },
                {
                    title: "shoppingCard.title",
                    route: "shoppingCard.view",
                    icon: "card_membership",
                },
            ],
        },
        {
            title: "profile.my_account",
            route: "profile.edit",
            icon: "person",
        },
        {
            title: "categories.title",
            route: "categories.index",
            icon: "category",
            children: [
                {
                    title: "categories.create",
                    route: "categories.create",
                    icon: "add",
                },
                {
                    title: "categories.edit",
                    route: "categories.edit",
                    icon: "edit",
                },
            ],
        },
        {
            title: "orders.title",
            route: "orders.index",
            icon: "request_quote",
            children: [
                {
                    title: "orders.create",
                    route: "orders.create",
                    icon: "add",
                },
                {
                    title: "orders.edit",
                    route: "orders.edit",
                    icon: "edit",
                },
            ],
        },
        {
            title: "orders.title",
            route: "orders.my",
            icon: "request_quote",
        },
        {
            title: "invoices.title",
            route: "invoices.index",
            icon: "receipt",
            children: [
                {
                    title: "invoices.create",
                    route: "invoices.create",
                    icon: "add",
                },
                {
                    title: "invoices.edit",
                    route: "invoices.edit",
                    icon: "edit",
                },
            ],
        },
        {
            title: "reservations.title",
            route: "reservations.index",
            icon: "book_online",
            children: [
                {
                    title: "reservations.create",
                    route: "reservations.create",
                    icon: "add",
                },
                {
                    title: "reservations.edit",
                    route: "reservations.edit",
                    icon: "edit",
                },
            ],
        },
        {
            title: "reservations.title",
            route: "reservations.my",
            icon: "book_online",
        },
        {
            title: "orderStatuses.title",
            route: "orderStatuses.index",
            icon: "update",
        },
        {
            title: "analytics.title",
            route: "analytics",
            icon: "area_chart",
        },
    ],
}
